/**
 * Helper per il flusso "prompt cartridge" Budget Pro → Claude Code locale.
 *
 * Il backend espone:
 *   GET  /api/admin/quant/prompt/templates
 *   POST /api/admin/quant/prompt/build  { template, context, custom_text, preferred_model }
 *      → { filename, content, slug, template, expected_output_path }
 *
 * Lato client offriamo:
 *   - download .prompt.md (saveAs blob)
 *   - copy to clipboard
 */

import { apiClient } from './api';

const PROMPTS_BASE = '/admin/quant/prompt';

export const listPromptTemplates = () =>
  apiClient.get(`${PROMPTS_BASE}/templates`);

export const buildPromptCartridge = (payload) =>
  apiClient.post(`${PROMPTS_BASE}/build`, payload);

/** Trigger download di un blob testuale come .prompt.md */
export const downloadCartridge = ({ filename, content }) => {
  const blob = new Blob([content], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 0);
};

/** Copia testo in clipboard con fallback per browser più vecchi */
export const copyToClipboard = async (text) => {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fallthrough
    }
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(ta);
  return ok;
};

/**
 * Costruisce il dict `context` standardizzato da iniettare nel cartridge.
 * Viene chiamato dalla pagina /admin/quant/lab quando l'utente apre il builder.
 */
export const buildContextFromChart = ({
  strategy,
  asset,
  tickers,
  period,
  signalDate,
  signalType,
  regime,
  regimeFilter,
  extra = {},
}) => {
  const ctx = {};
  if (strategy) ctx.strategy = strategy;
  if (asset) ctx.asset = asset;
  if (tickers?.length) ctx.tickers = tickers;
  if (period?.length === 2) ctx.period = period;
  if (signalDate) ctx.signal_date = signalDate;
  if (signalType) ctx.signal_type = signalType;
  if (regime) ctx.regime = regime;
  if (regimeFilter) ctx.regime_filter = regimeFilter;
  return { ...ctx, ...extra };
};
